module.exports = __webpack_public_path__ + "static/media/bm.09839e2c.svg";